import React from 'react'

export interface SwitchToggleProps {
  isOpen: boolean
  onClick: () => void
}

const SwitchToggle: React.FC<SwitchToggleProps> = ({ isOpen, onClick }) => {
  return (
    <button
      className={`group w-[115px] p-[6px] rounded-full flex items-center justify-start cursor-pointer z-1 bg-gradient-switch-border bg-gradient-switch`}
      onClick={onClick}
    >
      <span className="sr-only">Toggle</span>
      <div
        className={`flex items-start justify-start w-full mr-9 transition-transform duration-300 transform ${isOpen ? 'translate-x-full' : 'translate-0'}`}
      >
        <div className="w-9 h-9 bg-green rounded-full"></div>
      </div>
    </button>
  )
}

export default SwitchToggle
